import type * as React from "react";

import { BoxStyled, BreadcrumbTypography, StyledButton } from "./Breadcrumb.styles";

interface BreadcrumbProps extends React.PropsWithChildren {
    onClick: () => void;
}

export const Breadcrumb: React.FunctionComponent<BreadcrumbProps> = ({ onClick, children, ...restProps }) => {
    return (
        <BoxStyled {...restProps}>
            <StyledButton variant="text" onClick={onClick}>
                <BreadcrumbTypography color="inherit" component="span" variant="body-long-02">
                    {children}
                </BreadcrumbTypography>
            </StyledButton>
        </BoxStyled>
    );
};
